import { createAction } from '@reduxjs/toolkit';
import { withPayloadType } from 'utils';

export const showApplicationFormStart = createAction(
  'SHOW_APPLICATION_FORM::START',
  withPayloadType<{ id: string; organizationId: string }>(),
);
